import { isConstructedOngoingDownload, type OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import type { BatchImportInfo, BatchImportMap } from '../premiere/interfaces';
import { invariant } from '@mimir/common/util/invariant';
import isEmpty from 'lodash/isEmpty';
import type { BatchImportNotifier } from '@mimir/client-common/model/batchImportNotifier';

export const pendingBatchImports: BatchImportMap = {};


export function addOrUpdateBatchImport(ongoingDownload: OngoingDownload, notifier: BatchImportNotifier | undefined) {
  invariant(isConstructedOngoingDownload(ongoingDownload), 'Expected constructed ongoing download for batch import');
  const batchImportId = ongoingDownload.batchImportId;
  if (!batchImportId || isEmpty(batchImportId)) {
    return;
  }

  let batchImportInfo: BatchImportInfo = { id: batchImportId, filesPendingImport: [], allFilesAdded: false, notifier };
  if (pendingBatchImports[batchImportId]) {
    batchImportInfo = pendingBatchImports[batchImportId];
  }

  batchImportInfo.filesPendingImport.push(ongoingDownload);
  pendingBatchImports[batchImportId] = batchImportInfo;
}

export function batchImportIsEmpty(batchImportId: string): boolean {
  return !(batchImportId in pendingBatchImports);
}

export function completeBatchImportCreation(batchImportId: string, notifier: BatchImportNotifier | undefined, sequenceName: string | undefined) {
  if (!batchImportId || isEmpty(batchImportId)) {
    return;
  }

  let batchImportInfo: BatchImportInfo = { id: batchImportId, filesPendingImport: [], allFilesAdded: false, notifier };
  if (pendingBatchImports[batchImportId]) {
    batchImportInfo = pendingBatchImports[batchImportId];
  }

  batchImportInfo.allFilesAdded = true;
  batchImportInfo.sequenceName = sequenceName;
  pendingBatchImports[batchImportId] = batchImportInfo;
}


export function removeBatchImport(batchImportId: string): boolean {
  if (!batchImportId || isEmpty(batchImportId) || !pendingBatchImports[batchImportId]) {
    return false;
  }
  delete pendingBatchImports[batchImportId];
  return true;
}
